import { render } from "./LoadingComponent.vue?vue&type=template&id=24b177b2&lang=html"
import script from "./LoadingComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingComponent.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__